import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Avatar, Button, Stack } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";
import "./Header.css";
import "./Products.css";
import { useHistory } from "react-router-dom";
import { Search, SentimentDissatisfied } from "@mui/icons-material";
import {
  CircularProgress,
  Grid,
  InputAdornment,
  TextField,
} from "@mui/material";

const Header = (props) => {
  // { children, hasHiddenAuthButtons}
  // console.log(props.hasHiddenAuthButtons);
  // console.log(props.children);

  const history = useHistory();
  // console.log(history);

  function clickLogin() {
    history.push("/login");
  }

  function clickRegister() {
    history.push("/register");
  }

  function clickLogOut() {
    localStorage.removeItem("token");
    localStorage.removeItem("username");
    localStorage.removeItem("balance");
    history.push("/");
    window.location.reload();
  }

  function clickExplore() {
    history.push("/");
  }

  return (
    <Box className="header">
      <Box m={1} className="header-title">
        <img src="logo_light.svg" alt="QKart-icon"></img>
      </Box>

      {/* It is implementing search for desktop coming from Products <Header></Header> */}
      {props.children}

      {props.hasHiddenAuthButtons ? (
        <Button
          onClick={clickExplore}
          className="explore-button"
          startIcon={<ArrowBackIcon />}
          variant="text"
        >
          Back to explore
        </Button>
      ) : (
        <Stack
          direction="row"
          justifyContent="flex-end"
          alignItems="flex-start"
          spacing={2}
        >
          {localStorage.getItem("username") ? (
            <>
              <Stack
                direction="row"
                justifyContent="flex-end"
                alignItems="center"
                spacing={3}
              >
                
                <Avatar alt="crio.do i" src="avatar.png" />
                <div>
                  {localStorage.getItem("username")}
                </div>
              

                <Button variant="text" onClick={clickLogOut}>
                  LOGOUT
                </Button>
              </Stack>
            </>
          ) : (
            <>
              <Button variant="text" onClick={clickLogin}>
                Login
              </Button>
              <Button onClick={clickRegister} variant="contained">
                Register
              </Button>
            </>
          )}
        </Stack>
      )}
    </Box>
  );
};

export default Header;
